/**
 * GraphQL relay connection cursors encode a 0-based offset, so numbered pagination
 * can jump to any page by encoding that offset as base64.
 */
export function encodeCursor(offset: number): string {
  return btoa(offset.toString());
}
